import { capitalize as s, cached as o } from "../../../utils/utils.js";
import { warn as p } from "../../../utils/console.js";
import w from "lodash/get";
const W = o((e) => e.toString().toLowerCase().trim());
let n = 0;
function v(e, { rowsMap: t, rowKey: i, groupConfig: a, treeConfig: r }) {
  if (t.has(e[i]))
    return {
      key: e[i]
    };
  const d = a && a.enabled, f = r && r.children;
  if (d || f) {
    const l = f ? this.treeConfig.children : "children";
    return h(e, [...t.values()], i, l);
  }
  return null;
}
function h(e, t, i, a) {
  for (const r of t)
    if (r[a]) {
      const d = r[a].findIndex((l) => l[i] === e[i]);
      if (d > -1)
        return {
          rowSet: r[a],
          targetRowIndex: d
        };
      const f = h(e, r[a], i, a);
      if (f)
        return f;
    }
  return null;
}
function b(e, t) {
  const i = t.ariaLevel || 1;
  return e.reduce((a, r, d) => {
    const f = {
      ...r,
      ariaLevel: i,
      ariaSetSize: e.length,
      ariaPosInSet: d + 1
    }, l = r[t.childKey];
    return l ? (f.childRowCount = l.length, t.dropChildRows && delete f[t.childKey]) : f.childRowCount = 0, a.push(f), l && t.childRowFilter(r) && a.push(...b(l, { ...t, ariaLevel: i + 1 })), a;
  }, []);
}
function x(e) {
  e = e.split(" ");
  for (let t = 0, i = e.length; t < i; t++)
    e[t] = s(e[t]);
  return e.join(" ");
}
function M(e) {
  if (["tree", "checkbox", "index"].includes(e.type) && (e = {
    ...e,
    width: e.width || 36,
    widthType: "fixed",
    sortable: !1,
    visible: !0,
    downloadable: !1,
    allowResize: !1,
    allowReorder: !1
  }), e.type === "actions" && (e.allowResize = !1, e.allowReorder = !1, e.downloadable = !1), e.label && !e.width) {
    const t = document.createElement("canvas"), i = t.getContext("2d");
    i.font = '700 14px "Inter", Helvetica Neue, Arial, sans-serif';
    const a = x(e.label);
    i.clearRect(0, 0, t.width, t.height);
    let { width: r } = i.measureText(a);
    e.labelWidth = r, r += 32, e.sortable && (r += 26), e.filters && (r += 26);
    let d;
    e.minWidth ? d = Math.max(e.minWidth, Math.ceil(r)) : d = Math.min(Math.ceil(r), 280), e.minWidth = d, e.widthType = e.widthType || "flex";
  }
  return !e.width && !e.minWidth && (p(`no width or minWidth detected for column '${e.prop}'`), e.minWidth = 36, e.widthType = "flex"), e.width && (e.widthType = "fixed"), {
    align: e.align,
    allowResize: e.allowResize !== !1,
    allowReorder: e.allowReorder !== !1,
    append: e.append,
    async: !!e.async,
    colSpan: 1,
    columnKey: e.columnKey || e.prop || e.property || e.type,
    downloadable: e.downloadable !== !1,
    exact: e.exact,
    filterMethod: e.filterMethod,
    filterMultiple: e.filterMultiple,
    filters: (e.filters || []).map(({ label: t, value: i }) => ({
      prop: e.prop,
      label: t,
      value: i,
      checked: !1
    })),
    fixed: e.fixed === !0 || e.fixed === "left" ? "left" : e.fixed,
    fixedPos: 0,
    fixedShadow: !1,
    formatter: e.formatter,
    headerAlign: e.headerAlign,
    href: e.href,
    id: `col--${++n}`,
    indexMethod: e.indexMethod,
    label: e.label,
    labelWidth: e.labelWidth || e.minWidth,
    level: 1,
    minWidth: e.minWidth || 120,
    order: e.sortable ? e.order || "none" : null,
    property: e.prop || e.property,
    renderHeight: 0,
    renderWidth: 0,
    replace: e.replace,
    resizeWidth: e.resizeWidth || 0,
    rowSpan: 1,
    // @values clamp,ellipsis,title
    showOverflow: e.showOverflow === !1 ? !1 : e.showOverflow || e.showOverflowTooltip || !0,
    slot: e.slot,
    sortable: e.sortable,
    sortBy: e.sortBy,
    sortMethod: e.sortMethod,
    target: e.target,
    to: e.to,
    tooltipFormatter: e.tooltipFormatter,
    treeNode: e.treeNode,
    type: e.type,
    visible: e.visible,
    width: e.width,
    widthType: e.widthType
  };
}
function T(e, t) {
  return w(e, t);
}
export {
  x as capitalizeColumnLabel,
  h as findNestedRowLocation,
  v as findRowLocation,
  b as flattenChildRows,
  M as getColumnConfig,
  T as getProp,
  W as normalizeValue
};
//# sourceMappingURL=utils.js.map
